import React from 'react'
import { useAppContext } from '@/context/app'
import { formatDateOnly, getReportsFromDay } from '@/common/time'
import './ReportsFromDayNotice.css'

// Informs from which day reports can be generated (rendered only if the limit is set).
export const ReportsFromDayNotice = () => {
  const { translates } = useAppContext()
  const fromDay = getReportsFromDay()
  if (!translates || !fromDay) {
    return null
  }
  const text = translates.for('report.from_day_notice', 'Reports can be generated from {day}.')
  return <p className='reports-from-day-notice'>{text.replace('{day}', formatDateOnly(fromDay))}</p>
}
